import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import {
  PegaseDialogConfig,
  PegaseDialogConfigWithComponent,
  PegaseDialogWrapperComponent
} from './pegase-dialog-wrapper/pegase-dialog-wrapper.component';
import { DialogBoxBouton, DialogBoxData } from './dialog-box-configuration';
import { DialogBoxComponent } from './dialog-box.component';
import { ComponentType } from '@angular/cdk/portal';

@Injectable()
export class DialogBoxService {
  private _dialog: MatDialog = inject(MatDialog);

  /**
   * @deprecated remplacé par DialogBoxService.openComponent() (nouveau thème pégase)
   * @param data
   * @param buttons
   */
  public openDialog(data: DialogBoxData, ...buttons: Array<DialogBoxBouton>) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.disableClose = buttons.length !== 0;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { data: data, buttons: buttons };

    const dialogRef = this._dialog.open(DialogBoxComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((buttonClicked: DialogBoxBouton) => {
      if (buttonClicked && buttonClicked.action) {
        buttonClicked.action();
      }
    });
  }

  /**
   * Méthode remplaçant DialogBoxService.openDialog()
   * @param config
   */
  public open(config: PegaseDialogConfig<unknown>): void {
    const dialogConfig = {
      projectionDansUnMatDialogContent: true,
      panelClass: 'dialog-with-overflow',
      disableClose: config.buttons?.length !== 0,
      autoFocus: true,
      maxWidth: '90vw',
      maxHeight: '90vh',
      ...config,
      data: config,
    };

    const dialogRef = this._dialog.open(
      PegaseDialogWrapperComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((buttonClicked: DialogBoxBouton) => {
      if (buttonClicked && buttonClicked.action) {
        buttonClicked.action();
      }
    });
  }

  /**
   *
   * @param component
   * @param config
   */
  public openComponent<T, D = unknown>(
    component: ComponentType<T>,
    config: PegaseDialogConfig<D>
  ): MatDialogRef<T> {
    const dialogConfig: MatDialogConfig<PegaseDialogConfigWithComponent> = {
      panelClass: 'dialog-with-overflow',
      autoFocus: true,
      maxWidth: '90vw',
      maxHeight: '90vh',
      projectionDansUnMatDialogContent: true,
      ...config,
      data: { ...config, component },
    };

    const dialogRef = this._dialog.open<
      PegaseDialogWrapperComponent,
      PegaseDialogConfigWithComponent
    >(PegaseDialogWrapperComponent, dialogConfig);

    return dialogRef as unknown as MatDialogRef<T>;
  }
}
